export default "__VITE_ASSET__C1OZ$6uh__"